import { useGlobalContext } from '#contexts/GlobalContext';
import { PERMISSION_LOADING } from '@vindr/services/constants/common.constant';
import { LoadingIndicatorProgress } from '@vindr/ui';
import { useEffect, useMemo, useState } from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({
  permissions,
  children,
}: {
  permissions?: string[];
  children: JSX.Element;
}) => {
  const { keycloak } = useGlobalContext();
  const [authInit, setAuthInit] = useState(keycloak.initiated);

  useEffect(() => {
    if (!keycloak.initiated) {
      keycloak.init(() => {
        setAuthInit(true);
      });
    }
  }, []);

  const hasPermission = permissions && permissions?.length > 0;
  const permissionsList = keycloak.getPermissions();

  const hasPermissionInAccount = useMemo(() => {
    if (!permissionsList || permissionsList?.length === 0) return null;
    if (!hasPermission) return false;

    return keycloak.hasOneOfPerm(permissions);
  }, [hasPermission, permissions, permissionsList]);

  if (!authInit || (permissionsList && permissionsList?.includes(PERMISSION_LOADING)))
    return <LoadingIndicatorProgress className="h-full w-full bg-black" />;
  if (hasPermissionInAccount) return children;

  return <Navigate to="/no-permission" />;
};

export default ProtectedRoute;
